import { useState, useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Paperclip, Mic, LayoutGrid } from 'lucide-react';
import PartnerDashboardPage from '@/pages/partner/dashboard/page';

export default function HomePage() {
  const { effectiveRole } = useAuth();
  const [input, setInput] = useState('');

  const isPartner = effectiveRole === 'partner_principal' || effectiveRole === 'partner_staff';

  const greeting = useMemo(() => {
    const h = new Date().getHours();
    if (h < 12) return 'Good morning.';
    if (h < 18) return 'Good afternoon.';
    return 'Good evening.';
  }, []);

  const handleAsk = () => {
    if (!input.trim()) {
      const event = new KeyboardEvent('keydown', { key: 'k', metaKey: true });
      window.dispatchEvent(event);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') handleAsk();
  };

  if (isPartner) {
    return <PartnerDashboardPage />;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-52px)] w-full">
      <div className="flex flex-col items-center w-full max-w-xl px-6 -mt-12">
        {/* Greeting */}
        <h1
          className="text-4xl md:text-[52px] font-bold text-balance text-center animate-fade-up"
          style={{
            color: '#6b7280',
            letterSpacing: '-0.04em',
            lineHeight: 1.15,
          }}
        >
          {greeting}
        </h1>

        {/* Subline */}
        <p
          className="text-[13px] mt-3 text-center animate-fade-up stagger-1"
          style={{ color: '#9ca3af' }}
        >
          Nova is here to help you make sense of your data.
        </p>

        {/* Pill input bar */}
        <div className="mt-8 w-full flex justify-center animate-fade-up stagger-2">
          <div
            className="w-full max-w-lg flex items-center gap-3 px-4 py-3 rounded-full border transition-all duration-300 focus-within:border-[var(--border-hover)]"
            style={{
              background: 'var(--bg-surface-raised)',
              borderColor: 'var(--border-primary)',
            }}
          >
            <Paperclip size={16} style={{ color: '#9ca3af' }} />
            <input
              type="text"
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ask Nova anything..."
              className="flex-1 bg-transparent text-[13px] outline-none placeholder:text-[#c4c4c4]"
              style={{ color: 'var(--text-primary)' }}
            />
            <div className="flex items-center gap-1.5">
              <button
                className="flex items-center justify-center w-7 h-7 rounded-full transition-colors duration-200 hover:bg-black/5"
                style={{ color: '#9ca3af' }}
              >
                <Mic size={15} />
              </button>
              <button
                className="flex items-center justify-center w-7 h-7 rounded-full transition-colors duration-200 hover:bg-black/5"
                style={{ color: '#9ca3af' }}
              >
                <LayoutGrid size={15} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}